import {defaultState} from './state';
import * as UIActions from '../actions/UIActions';

const countrySelector = (state = defaultState.countrySelector, action) => {

    switch (action.type) {
        case UIActions.INIT_APP_ACTION.name:
            return {
                ...state,
                countrySelected: action.country
            };
        default:
            return state;
    }
};

export default countrySelector;